<!--
Author: TangChen
Date: 2018-10-17
Desc: 找回登录密码，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-reset-lpwd bizcomp ' + className">
        <comp-title :title="title" />
        <nav-tips :data="titTips" />
        <reset-pwd :way="way" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import navTips from "@/components/form/navTips.vue";
import resetPwd from "@/components/acctInfo/resetPwd.vue";
export default {
    name: "Resetlpwd",
    components: {
        navTips,
        resetPwd
    },
    mixins: [mixin],
    data () {
        return {
            titTips: {
                tit: "找回登录密码",
                text: "登录密码可用于快速登录网站/网上交易/APP/微信",
                cla: "login-pwd"
            },
            way: "login"
        };
    },
    methods: {
    // 账户绑定选项处理
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.bizcomp-reset-lpwd {
}
</style>
